// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__TmisW","title":"styles_title__R_Z0A","container":"styles_container__kYBo5"};